import { render, staticRenderFns } from "./RequerAtencaoItem.vue?vue&type=template&id=6a6ce992&scoped=true"
import script from "./RequerAtencaoItem.vue?vue&type=script&lang=js"
export * from "./RequerAtencaoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ce992",
  null
  
)

export default component.exports